import { useApiRequest } from '~/hooks/api';
import { ICrisisCall, ICrisisCallsAllocatedClients } from '~/services/api/crisis/types';
import { useStoreActions, useStoreState } from '~/store/hooks';

interface IUseGetCrisisCalls {
  isLoading: boolean;
  crisisCalls: ICrisisCall[];
  allocatedClients: ICrisisCallsAllocatedClients[];
  refetchCrisisCalls: () => void;
}

interface IUseGetCrisisCallsProps {
  enabled?: boolean;
}

const useGetCrisisCalls = ({
  enabled = true,
}: IUseGetCrisisCallsProps = {}): IUseGetCrisisCalls => {
  const user = useStoreState(state => state.user.current);
  const clinicId = user?.clinic?.id;

  const { crisisCalls, allocatedClients } = useStoreState(state => state.crisis);

  const { onGetCrisisCalls } = useStoreActions(actions => actions.crisis);

  const { isLoading, refetch: refetchCrisisCalls } = useApiRequest<{
    crisisCalls: ICrisisCall[];
    allocatedClients: ICrisisCallsAllocatedClients[];
  }>(() => onGetCrisisCalls({ clinicId: String(clinicId) }), {
    enabled: !!clinicId && enabled,
  });

  return {
    isLoading,
    crisisCalls,
    allocatedClients,
    refetchCrisisCalls,
  };
};

export default useGetCrisisCalls;
